<template>
    <div class="banner">
      <a-carousel :autoplay="true" :dotPosition="'left'">
        <div><img :src="require('../../../assets/weapon/weaponbanner1.png')" alt="" class="bannerImage"></div>
        <div><img :src="require('../../../assets/weapon/weaponbanner1.png')" alt="" class="bannerImage"></div>
      </a-carousel>
    </div>
</template>

<script>

export default {
  name: 'Banner',
  components: {},
  mounted () {},
  data () {
    return {
      title: 'banner'
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.banner{
  height:500px;
  .bannerImage{
    height: 500px;
    width:100%;
  }
  .bannerBottom{
    position: absolute;
    display: flex;
    justify-content:space-around;
    align-items:center;
    bottom: 0px;
    width: 100%;
    padding: 15px 300px;
    background:rgba(0, 0, 0, 0.6);
    div{
      color: white;
      p{
        margin-bottom:0;
      }
      .number{
        font-size: 25px;
        font-weight: 600;
      }
    }
  }
}
.banner /deep/ .slick-slide {
  border: none;
}
.banner /deep/ .ant-carousel .slick-vertical .slick-slide{
  border: none;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/Banner.vue